import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=632eb321&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=632eb321&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632eb321",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632eb321')) {
      api.createRecord('632eb321', component.options)
    } else {
      api.reload('632eb321', component.options)
    }
    module.hot.accept("./PasswordResetForm.vue?vue&type=template&id=632eb321&scoped=true", function () {
      api.rerender('632eb321', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/PasswordResetForm.vue"
export default component.exports